import React from 'react';
import { ParallaxImage } from '../ui/ParallaxImage';
import { TextLink } from '../ui/TextLink';
import { motion } from 'framer-motion';
export function Threshold() {
  return <section id="index" className="relative h-screen w-full flex items-end pb-24 md:pb-32" data-id="element-200">
      <div className="absolute inset-0 z-0" data-id="element-201">
        <ParallaxImage src="https://cdn.magicpatterns.com/uploads/dXESK41oaqD19KNXTy2tsJ/spaces-image2.jpg" alt="Forest path" className="w-full h-full" overlay={<>
              {/* 1. Base uniform darkening pass */}
              <div className="absolute inset-0 bg-[rgba(10,9,7,0.55)]" data-id="element-203" />
              {/* 2. Bottom-weighted gradient pooling darkness behind text */}
              <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(10,9,7,0)_0%,rgba(10,9,7,0.85)_100%)]" data-id="element-204" />
              {/* 3. Subtle vignette */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(10,9,7,0)_0%,rgba(10,9,7,0.4)_100%)]" data-id="element-205" />
            </>} data-id="element-202" />
      </div>

      <div className="container relative z-10 mx-auto px-8 md:px-6" data-id="element-206">
        <div className="max-w-4xl mt-[35vh] md:mt-0" data-id="element-207">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 1.5
        }} data-id="element-208">
            <p className="font-mono text-[12px] tracking-[0.2em] uppercase text-parchment mb-6" data-id="element-209">
              CHAPTER ZERO. AN INVITATION.
            </p>

            <h1 className="font-serif italic font-medium text-white text-4xl md:text-6xl lg:text-[96px] leading-[1.1] mb-8" style={{
            textShadow: '0 2px 24px rgba(0, 0, 0, 0.6)'
          }} data-id="element-210">
              There is a space between what is and what could be. I design
              within it.
            </h1>

            <p className="font-mono text-[14px] leading-[1.8] text-parchment max-w-[540px] mb-12" data-id="element-211">
              A boutique interior design studio in Scottsdale, Arizona. Led by
              Anna Paty, designer and writer.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 sm:gap-12" data-id="element-212">
              <a href="#studio" className="group inline-flex items-center font-mono lowercase tracking-wide text-white transition-opacity hover:opacity-70" data-id="element-213">
                <span className="border-b-[1.5px] border-white pb-0.5 transition-all duration-300 group-hover:border-transparent" data-id="element-214">
                  enter the studio &rarr;
                </span>
              </a>
              <a href="#begin" className="group inline-flex items-center font-mono lowercase tracking-wide text-white transition-opacity hover:opacity-70" data-id="element-215">
                <span className="border-b-[1.5px] border-white pb-0.5 transition-all duration-300 group-hover:border-transparent" data-id="element-216">
                  and begin a project &rarr;
                </span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}